import $ from "jquery";
window.$ = window.jQuery = $;

import * as bootstrap from "bootstrap";
window.bootstrap = bootstrap;

import "bootstrap-datepicker";
import "bootstrap-slider";
import "bootstrap-validator";

import DataTable from "datatables.net";
import "datatables.net-responsive";
window.DataTable = DataTable;

import '@fortawesome/fontawesome-free/js/all.js';

import "timepicker";

import * as tempusDominus from "@eonasdan/tempus-dominus";
window.tempusDominus = tempusDominus;

import Chart from 'chart.js/auto';
window.Chart = Chart;

import Inputmask from "inputmask";
Inputmask.extendDefaults({
    'autoUnmask': true
});
window.Inputmask = Inputmask;
$.fn.inputmask = function(options) {
    if(options === 'unmaskedvalue'){
        const el = this[0];
        if (el && el.inputmask && typeof el.inputmask[options] === 'function') {
            return el.inputmask[options]();
        }
        return undefined;
    }

    return this.each(function() {
        new Inputmask(options).mask(this);
    });
};

import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';

window.FullCalendar = {
    Calendar: Calendar
};
window.FullCalendarPlugins = {
    dayGrid: dayGridPlugin,
    timeGrid: timeGridPlugin,
    interaction: interactionPlugin
};

import "owl.carousel";